import { SVGProps, Ref, forwardRef } from 'react';

export const RadiusOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M3.216 3.74C2.32 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.291 5.524 14.1 8 14.1s3.925-.809 4.784-1.84C13.68 11.184 14.1 9.667 14.1 8c0-.7-.074-1.374-.226-2h1.433c.132.652.193 1.326.193 2 0 3.75-1.875 7.5-7.5 7.5S.5 11.75.5 8 2.375.5 8 .5c.728 0 1.393.063 2 .18v1.431A8.8 8.8 0 0 0 8 1.9c-2.476 0-3.925.809-4.784 1.84"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m13.015 3.975-2.642 2.641c.206.42.293.902.293 1.384 0 1.333-.666 2.666-2.666 2.666S5.333 9.333 5.333 8 6 5.333 8 5.333c.564 0 1.022.106 1.389.288l2.638-2.638A2 2 0 0 1 12 2.667c0-.667.333-1.334 1.333-1.334s1.333.667 1.333 1.334c0 .666-.333 1.333-1.333 1.333q-.171 0-.318-.025M6.992 7.063c-.141.17-.259.478-.259.937s.118.767.259.937c.104.125.345.33 1.008.33s.904-.205 1.008-.33c.141-.17.259-.478.259-.937s-.118-.767-.26-.937c-.103-.125-.344-.33-1.007-.33s-.904.205-1.008.33"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
RadiusOutlinedSize16Glyph.displayName = 'RadiusOutlinedSize16Glyph';
